export const BADGE_FEATURE_LAZY = 'badgeFeatureLazy';
export const BADGE_UI_REQUEST_COUPON_LAZY = 'badgeUiRequestCouponLazy';
